import { render, staticRenderFns } from "./modal-exit.vue?vue&type=template&id=10a2dc8e&"
import script from "./modal-exit.vue?vue&type=script&lang=js&"
export * from "./modal-exit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "modal-exit.vue"
export default component.exports